import type { Quiz409Translations } from './quizExpired.translation.pl.ts';

export const quizToManyRevisitsTranslations: Quiz409Translations = {
  title: 'Oops! Too many attempts!',
  subMessage:
    "This year you didn't manage to complete all the qualification tasks. You can no longer log in.",
  buttons: {
    back: 'Start',
  },
};
